/*global FB */
import React from 'react'
import {
  HashRouter,
  //  Link,
  Redirect
} from 'react-router-dom'
import {
  userAcivity,
  signupActivitys,
  activities
} from '../../../config/constant'
/*import {
  singUpAct,
  wouldYouJoin,
  wantToJoin,
  viewAll
} from '../../../app-text-files/enText'*/
import {
  setCurrentActivity,
  setSignUpActivities
} from '../../../action/activityAction';
import { firstOnHome } from '../../../action/action'
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { setColor, hoverColor } from '../../../JS/setColors'

class userActivity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldRedirect: false,
      signUp: false
    }
  }

  componentDidMount() {
    this.props.setSignUpActivities(signupActivitys);
    if (this.props.firstTimeOnHome) {
      //console.log("new state userActivity", this.props.firstTimeOnHome);
      this.props.firstOnHome(false);
      setColor(this.props.menuColor);
    }
  }
  componentDidUpdate() {
    //hoverColor('.sch-link', this.props.menuColor);
  }
  //setting clicked activity as current activity 
  onActivityClick = (currentActivity) => {
    this.props.setCurrentActivity(currentActivity);
    this.setState({ shouldRedirect: true })
  }

  //it will show list of activities form activity page 
  showActivityList = () => {
    let count = 0, currentArray;
    if (this.props.signUpActivities.length > 0) {
      currentArray = this.props.signUpActivities;
      if (this.state.signUp !== true) {
        this.setState({ signUp: true })
      }
    } else {
      currentArray = this.props.activities;
      if (this.state.signUp !== false) {
        this.setState({ signUp: false })
      }
    }
    return (
      <div className="schedules">
        {
          Array.isArray(currentArray) ?
            currentArray.map((iterator) => {
              if (count < 3) {
                count++;
                return (

                  <div className="sch-link"
                    onClick={() => { this.onActivityClick(iterator) }}
                   style={{ color: "inherit" }}
                    >
                    <span clssName="timeInActvity" 
                     style={{ color: "inherit", background: "inherit" }}
                    >
                      {iterator.startTime || "No Specific Time"}
                    </span>
                    {iterator.name || "Comman activity"}
                  </div>
                )
              }
            }) : ""
        }
      </div>
    )
  }
  //it will set function to redirect at activity page
  redirectToActivites = () => {
    this.setState({ shouldRedirect: true })
  }

  temp = () => {
    alert(`url:${window.location.href}`);
  }

  render() {
    return (
      <div id="usrActivity" className="widget col col-2 h-auto m-r25">
        <div className="widget-contents">
          <div className="widget-heading">
            {this.state.signUp ? this.props.stringConst.singUpAct : this.props.stringConst.wouldYouJoin}
          </div>
          <div
            id="viewAllActivity"
            className="widget-body"
            style={{ padding: 0 }}>
            {
              this.showActivityList()
            }
          </div>
          {
            this.state.shouldRedirect ?
              <HashRouter>
                <Redirect to={"/activities"} />
              </HashRouter>
              : null
          }
          <div
            className="widget-btn-main view-all"
            onClick={this.redirectToActivites}>
            {this.state.signUp ?
              this.props.stringConst.wantToJoin :
              this.props.stringConst.viewAll}
            <i class="fa fa-plus" style={{ color: "inherit" }}></i>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    activities: state.store.activity.activitiesData.activityMaster ?
      state.store.activity.activitiesData.activityMaster : [],
    signUpActivities: state.store.activity.signUpactivities,
    stringConst: state.store.home.stringConst,
    firstTimeOnHome: state.store.home.firstTimeOnHome,
    menuColor: state.store.home.MenuColor
  }
}

userActivity.propTypes = {
  signUpActivities: propTypes.arrayOf(propTypes.object),
  stringConst: propTypes.object
}

export default connect(
  mapStateToProps,
  {
    setCurrentActivity,
    setSignUpActivities,
    firstOnHome
  }
)(userActivity);